import _extends from "@babel/runtime/helpers/esm/extends";
export var isEqualJson = function isEqualJson(a, b) {
  return a === b || JSON.stringify(a) === JSON.stringify(b);
};
export var parseJson = function parseJson(json, defaultValue) {
  try {
    return JSON.parse(json);
  } catch (e) {
    return defaultValue;
  }
};
export var cleanObject = function cleanObject(obj) {
  return obj === null ? undefined // null -> undefined
  : Array.isArray(obj) ? obj.filter(function (v) {
    return v !== null;
  }).map(cleanObject) // Clean array
  : typeof obj === 'object' ? Object.keys(obj) // Clean object
  .filter(function (k) {
    return obj[k] !== null;
  }).reduce(function (target, k) {
    var _extends2;

    return _extends({}, target, (_extends2 = {}, _extends2[k] = cleanObject(obj[k]), _extends2));
  }, {}) : obj;
};